// ===== G5 Network — Main JavaScript =====

document.addEventListener('DOMContentLoaded', function () {

  // ----- Hero Slider -----
  const slides = document.querySelectorAll('.hero-slide');
  const dotsContainer = document.getElementById('heroDots');
  let currentSlide = 0;
  let slideInterval;

  if (slides.length > 0 && dotsContainer) {
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.classList.add('hero-dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    });

    function goToSlide(n) {
      slides[currentSlide].classList.remove('active');
      dotsContainer.children[currentSlide].classList.remove('active');
      currentSlide = n;
      slides[currentSlide].classList.add('active');
      dotsContainer.children[currentSlide].classList.add('active');
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    slideInterval = setInterval(nextSlide, 5000);
    const hero = document.querySelector('.hero');
    if (hero) {
      hero.addEventListener('mouseenter', () => clearInterval(slideInterval));
      hero.addEventListener('mouseleave', () => { slideInterval = setInterval(nextSlide, 5000); });
    }
  }

  // ----- Mobile Menu Toggle -----
  const menuToggle = document.getElementById('mobileMenuToggle');
  const mainNav = document.getElementById('mainNav');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', () => {
      mainNav.classList.toggle('open');
      const icon = menuToggle.querySelector('i');
      icon.classList.toggle('fa-bars');
      icon.classList.toggle('fa-times');
    });
  }

  // ----- Product Tabs -----
  const tabBtns = document.querySelectorAll('.tab-btn');
  const productCards = document.querySelectorAll('.product-card[data-tab]');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      productCards.forEach(card => {
        card.style.display = card.dataset.tab === tab ? 'block' : 'none';
      });
    });
  });

  // ----- Quote System (localStorage) -----
  const QUOTE_KEY = 'g5_quote_items';

  function getQuoteItems() {
    try { return JSON.parse(localStorage.getItem(QUOTE_KEY)) || []; }
    catch { return []; }
  }

  function saveQuoteItems(items) {
    localStorage.setItem(QUOTE_KEY, JSON.stringify(items));
    updateQuoteBadge();
  }

  function updateQuoteBadge() {
    const badge = document.getElementById('quoteCount');
    if (badge) {
      const count = getQuoteItems().length;
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function addToQuote(productName) {
    const items = getQuoteItems();
    if (!items.find(item => item.name === productName)) {
      items.push({ name: productName, qty: 1, added: new Date().toISOString() });
      saveQuoteItems(items);
      showNotification(productName + ' added to quote list');
    } else {
      showNotification('Already in your quote list');
    }
  }

  function removeFromQuote(productName) {
    const items = getQuoteItems().filter(item => item.name !== productName);
    saveQuoteItems(items);
  }

  // Attach "Add to Quote" buttons
  document.querySelectorAll('.add-to-quote').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      addToQuote(btn.dataset.product);
    });
  });

  // Quote page table rendering
  const quoteTableBody = document.getElementById('quoteTableBody');
  if (quoteTableBody) renderQuoteTable();

  function renderQuoteTable() {
    if (!quoteTableBody) return;
    const items = getQuoteItems();
    if (items.length === 0) {
      quoteTableBody.innerHTML = '<tr><td colspan="4" style="text-align:center;padding:40px;color:#6c757d;">Your quote list is empty. Browse products and click "Get Quote" to add items.</td></tr>';
      return;
    }
    quoteTableBody.innerHTML = items.map((item, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${item.name}</td>
        <td><input type="number" value="${item.qty}" min="1" class="form-control" style="width:80px" data-index="${i}" onchange="updateQty(this)"></td>
        <td><button class="remove-btn" onclick="removeItem('${item.name.replace(/'/g, "\\'")}')"><i class="fas fa-trash"></i> Remove</button></td>
      </tr>
    `).join('');
  }

  window.removeItem = function (name) { removeFromQuote(name); renderQuoteTable(); };
  window.updateQty = function (input) {
    const items = getQuoteItems();
    const idx = parseInt(input.dataset.index);
    if (items[idx]) { items[idx].qty = parseInt(input.value) || 1; saveQuoteItems(items); }
  };

  updateQuoteBadge();

  // =============================================
  // ----- QUICK QUOTE MODAL (Single Item) -----
  // =============================================

  // Create the modal HTML and inject it into the page
  const modalHTML = `
  <div class="qq-overlay" id="qqOverlay">
    <div class="qq-modal">
      <button class="qq-close" id="qqClose">&times;</button>
      <div class="qq-header">
        <i class="fas fa-file-invoice" style="color:var(--amber);font-size:1.5rem;"></i>
        <h3>Quick Quote Request</h3>
      </div>
      <div class="qq-product-info" id="qqProductInfo"></div>
      <form id="qqForm">
        <div class="qq-row">
          <div class="qq-field">
            <label>Full Name *</label>
            <input type="text" id="qqName" required placeholder="Your name">
          </div>
          <div class="qq-field">
            <label>Company *</label>
            <input type="text" id="qqCompany" required placeholder="Company name">
          </div>
        </div>
        <div class="qq-row">
          <div class="qq-field">
            <label>Email *</label>
            <input type="email" id="qqEmail" required placeholder="you@company.com">
          </div>
          <div class="qq-field">
            <label>Phone</label>
            <input type="tel" id="qqPhone" placeholder="(555) 123-4567">
          </div>
        </div>
        <div class="qq-row">
          <div class="qq-field">
            <label>Quantity *</label>
            <input type="number" id="qqQty" value="1" min="1" required>
          </div>
          <div class="qq-field">
            <label>Preferred Contact</label>
            <select id="qqContact">
              <option>Email</option>
              <option>Phone</option>
              <option>Either</option>
            </select>
          </div>
        </div>
        <div class="qq-field">
          <label>Additional Notes</label>
          <textarea id="qqNotes" rows="3" placeholder="Any special requirements, configuration needs, or questions..."></textarea>
        </div>
        <div class="qq-payment-note">
          <i class="fas fa-info-circle"></i>
          <span>Orders under $5,000 — Shopify secure checkout &nbsp;|&nbsp; Orders $5,000+ — Wire / ACH invoice</span>
        </div>
        <button type="submit" class="qq-submit">
          <i class="fas fa-paper-plane"></i> Submit Quote Request
        </button>
      </form>
    </div>
  </div>`;
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Modal styles
  const qqStyles = document.createElement('style');
  qqStyles.textContent = `
    .qq-overlay {
      display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.55);
      z-index: 10000; justify-content: center; align-items: center;
      padding: 20px; backdrop-filter: blur(3px);
    }
    .qq-overlay.open { display: flex; }
    .qq-modal {
      background: #fff; border-radius: 14px; width: 100%; max-width: 560px;
      max-height: 90vh; overflow-y: auto; padding: 32px; position: relative;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3); animation: qqSlideUp 0.3s ease;
    }
    @keyframes qqSlideUp {
      from { transform: translateY(40px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    .qq-close {
      position: absolute; top: 14px; right: 18px; background: none; border: none;
      font-size: 1.8rem; color: #999; cursor: pointer; line-height: 1;
    }
    .qq-close:hover { color: #333; }
    .qq-header {
      display: flex; align-items: center; gap: 12px; margin-bottom: 20px;
    }
    .qq-header h3 { font-size: 1.3rem; font-weight: 700; color: #1a3a6e; margin: 0; }
    .qq-product-info {
      background: #f0f2f5; border-radius: 8px; padding: 14px 16px;
      margin-bottom: 20px; font-size: 0.9rem;
    }
    .qq-product-info .qq-pn {
      font-weight: 700; color: #1a3a6e; font-size: 1rem;
    }
    .qq-product-info .qq-desc {
      color: #495057; margin-top: 4px; font-size: 0.85rem;
    }
    .qq-product-info .qq-stock {
      margin-top: 6px; font-size: 0.82rem;
    }
    .qq-stock-badge {
      display: inline-flex; align-items: center; gap: 5px;
      background: #d4edda; color: #155724; padding: 2px 10px;
      border-radius: 12px; font-weight: 600; font-size: 0.78rem;
    }
    .qq-stock-badge i { font-size: 0.7rem; }
    .qq-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
    .qq-field { margin-bottom: 14px; }
    .qq-field label {
      display: block; font-weight: 600; font-size: 0.82rem;
      color: #495057; margin-bottom: 5px;
    }
    .qq-field input, .qq-field select, .qq-field textarea {
      width: 100%; padding: 10px 12px; border: 2px solid #e2e6ea;
      border-radius: 6px; font-family: inherit; font-size: 0.9rem;
      transition: border-color 0.2s;
    }
    .qq-field input:focus, .qq-field select:focus, .qq-field textarea:focus {
      outline: none; border-color: #1a3a6e;
    }
    .qq-payment-note {
      display: flex; align-items: center; gap: 8px; background: #fef3d0;
      border: 1px solid #e8a000; border-radius: 6px; padding: 10px 14px;
      font-size: 0.8rem; color: #856404; margin-bottom: 18px;
    }
    .qq-payment-note i { color: #e8a000; flex-shrink: 0; }
    .qq-submit {
      width: 100%; padding: 14px; background: #1a3a6e; color: #fff;
      border: none; border-radius: 8px; font-family: inherit;
      font-size: 1rem; font-weight: 600; cursor: pointer;
      display: flex; align-items: center; justify-content: center; gap: 8px;
      transition: background 0.2s;
    }
    .qq-submit:hover { background: #2a5298; }
    @media (max-width: 560px) {
      .qq-modal { padding: 20px; }
      .qq-row { grid-template-columns: 1fr; }
    }

    /* Quick Quote trigger button on product cards */
    .quick-quote-btn {
      display: inline-flex; align-items: center; gap: 5px;
      padding: 7px 14px; background: #e8a000; color: #0d2240;
      border: none; border-radius: 5px; font-family: inherit;
      font-size: 0.78rem; font-weight: 700; cursor: pointer;
      transition: all 0.2s; white-space: nowrap;
    }
    .quick-quote-btn:hover { background: #d49200; transform: translateY(-1px); }
    .quick-quote-btn i { font-size: 0.72rem; }

    /* Stock indicator badge */
    .stock-badge {
      display: inline-flex; align-items: center; gap: 4px;
      font-size: 0.75rem; font-weight: 600; padding: 2px 8px;
      border-radius: 10px;
    }
    .stock-badge.in-stock {
      background: #d4edda; color: #155724;
    }
    .stock-badge.low-stock {
      background: #fff3cd; color: #856404;
    }
    .stock-badge.out-of-stock {
      background: #f8d7da; color: #721c24;
    }
    .stock-badge i { font-size: 0.65rem; }

    /* Updated product footer with two buttons */
    .product-actions {
      display: flex; gap: 8px; align-items: center; flex-wrap: wrap;
    }
  `;
  document.head.appendChild(qqStyles);

  // Quick Quote modal logic
  const qqOverlay = document.getElementById('qqOverlay');
  const qqClose = document.getElementById('qqClose');
  const qqForm = document.getElementById('qqForm');
  const qqProductInfo = document.getElementById('qqProductInfo');
  let currentQuoteProduct = '';

  function openQuickQuote(partNo, description, mfg, qty, cond) {
    currentQuoteProduct = partNo;
    const stockQty = parseInt(qty) || 0;
    let stockHTML = '';
    if (stockQty > 10) {
      stockHTML = `<span class="qq-stock-badge"><i class="fas fa-check-circle"></i> ${stockQty} in stock</span>`;
    } else if (stockQty > 0) {
      stockHTML = `<span class="qq-stock-badge" style="background:#fff3cd;color:#856404;"><i class="fas fa-exclamation-circle"></i> ${stockQty} left — low stock</span>`;
    } else {
      stockHTML = `<span class="qq-stock-badge" style="background:#f8d7da;color:#721c24;"><i class="fas fa-times-circle"></i> Contact for availability</span>`;
    }

    qqProductInfo.innerHTML = `
      <div class="qq-pn"><i class="fas fa-barcode" style="opacity:0.5;margin-right:6px;"></i>${partNo}</div>
      <div class="qq-desc">${mfg || ''} ${description || ''}</div>
      <div class="qq-stock">${stockHTML} &nbsp; <span style="color:#6c757d;font-size:0.8rem;">Condition: ${cond || 'N/A'}</span></div>
    `;
    qqOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  window.openQuickQuote = openQuickQuote;

  if (qqClose) {
    qqClose.addEventListener('click', closeQuickQuote);
  }
  if (qqOverlay) {
    qqOverlay.addEventListener('click', (e) => {
      if (e.target === qqOverlay) closeQuickQuote();
    });
  }

  function closeQuickQuote() {
    qqOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Handle ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && qqOverlay.classList.contains('open')) closeQuickQuote();
  });

  // Handle Quick Quote form submission
  if (qqForm) {
    qqForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const data = {
        product: currentQuoteProduct,
        name: document.getElementById('qqName').value,
        company: document.getElementById('qqCompany').value,
        email: document.getElementById('qqEmail').value,
        phone: document.getElementById('qqPhone').value,
        qty: document.getElementById('qqQty').value,
        contact: document.getElementById('qqContact').value,
        notes: document.getElementById('qqNotes').value,
        timestamp: new Date().toISOString()
      };

      // Keep a local backup copy
      try {
        const quotes = JSON.parse(localStorage.getItem('g5_quick_quotes') || '[]');
        quotes.push(data);
        localStorage.setItem('g5_quick_quotes', JSON.stringify(quotes));
      } catch (err) {}

      // Email the quote request to Sales@ (CC Amber@) via FormSubmit
      const submitBtn = qqForm.querySelector('.qq-submit');
      const btnHTML = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Sending...'; }

      const payload = {
        _subject: 'Quick Quote Request: ' + (data.product || ''),
        _template: 'table',
        _cc: 'Amber@g5networkgroup.com',
        _replyto: data.email,
        'Part Number / Product': data.product,
        'Full Name': data.name,
        'Company': data.company,
        'Email': data.email,
        'Phone': data.phone,
        'Quantity': data.qty,
        'Preferred Contact': data.contact,
        'Additional Notes': data.notes
      };

      const finish = () => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = btnHTML; }
        closeQuickQuote();
        qqForm.reset();
        showNotification('Quote request submitted for ' + data.product + '! We\'ll respond within 2 hours.');
      };

      fetch('https://formsubmit.co/ajax/Sales@g5networkgroup.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then((r) => r.json())
        .then(finish)
        .catch(finish); // local backup already saved; confirm to the customer either way
    });
  }

  // ----- Toast Notification -----
  function showNotification(message) {
    const existing = document.querySelector('.toast-notification');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.innerHTML = '<i class="fas fa-check-circle"></i> ' + message;
    toast.style.cssText = `
      position: fixed; bottom: 30px; right: 30px; background: #1a3a6e; color: #fff;
      padding: 14px 24px; border-radius: 8px; font-size: 0.9rem; font-family: Inter, sans-serif;
      box-shadow: 0 8px 30px rgba(0,0,0,0.2); z-index: 9999; display: flex; align-items: center;
      gap: 10px; animation: slideIn 0.3s ease; max-width: 420px;
    `;
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  // Add animation keyframes
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100px); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `;
  document.head.appendChild(style);

  // ----- Search Form -----
  const searchForm = document.querySelector('.search-form');
  if (searchForm) {
    searchForm.addEventListener('submit', (e) => {
      const input = searchForm.querySelector('.search-input');
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
  }

  // ----- Sticky Header Shadow -----
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(0,0,0,0.1)'
        : '0 1px 3px rgba(0,0,0,0.08)';
    });
  }
});

